import React from "react";
import { Layout, Space, Button, Typography } from "antd";
import { CheckCircleFilled, MailOutlined } from "@ant-design/icons";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useThemedLogo } from "../../theme/useThemedLogo";

const { Title, Paragraph, Text } = Typography;

const BRAND_FOOTER =
  "This form is powered by Mailinflow Forms — a simple way to collect leads and stay in touch.";

export default function FormThankYou() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const logo = useThemedLogo();

  const confirmed = params.get("confirmed") === "1";
  const pendingConfirm = params.get("pending_confirm") === "1";
  const received = params.get("received") === "1";

  let title = "Thank you";
  let body =
    "Your submission was received successfully. The team behind this page will follow up if needed.";
  let icon = (
    <CheckCircleFilled style={{ fontSize: 52, color: "#0d6658" }} />
  );

  if (confirmed) {
    title = "Thank you";
    body =
      "Your submission is confirmed. You're all set — thanks for taking the time.";
    icon = (
      <CheckCircleFilled style={{ fontSize: 52, color: "#0d6658" }} />
    );
  } else if (pendingConfirm && received) {
    title = "Thank you";
    body =
      "Your submission was received. Please check your email and confirm using the link we sent — it helps keep everyone's inbox safer.";
    icon = (
      <MailOutlined style={{ fontSize: 52, color: "#16727b" }} />
    );
  } else if (received) {
    title = "Thank you";
    body =
      "Your submission was received successfully. The team behind this page will follow up if needed.";
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7f8" }}>
      <Space
        direction="vertical"
        align="center"
        style={{
          display: "flex",
          width: "100%",
          minHeight: "100vh",
          justifyContent: "center",
          padding: "32px 24px",
        }}
      >
        <img
          src={logo}
          alt="Mailinflow"
          height={28}
          style={{ display: "block", marginBottom: 20 }}
        />
        <Space
          direction="vertical"
          align="center"
          size="middle"
          style={{
            maxWidth: 460,
            width: "100%",
            textAlign: "center",
            background: "#fff",
            borderRadius: 12,
            padding: "40px 28px 36px",
            boxShadow: "0 8px 24px rgba(15, 20, 25, 0.06)",
            border: "1px solid #d8e0e3",
          }}
        >
          {icon}
          <Title level={3} style={{ margin: "8px 0 0", fontWeight: 600 }}>
            {title}
          </Title>
          <Paragraph
            style={{
              marginBottom: 0,
              fontSize: 15,
              lineHeight: 1.55,
              color: "#2d3a41",
            }}
          >
            {body}
          </Paragraph>
          <Text type="secondary" style={{ fontSize: 13, lineHeight: 1.5, display: "block" }}>
            {BRAND_FOOTER}
          </Text>
          <Button
            type="primary"
            size="large"
            onClick={() => navigate("/")}
            style={{ marginTop: 8 }}
          >
            Go to home
          </Button>
        </Space>
      </Space>
    </Layout>
  );
}
